'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'block-question';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e3dd';
var svgPathData = 'M32 64l0 384 384 0 0-384-384 0zM0 32l448 0 0 448-448 0 0-448zM88 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm248 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM88 368a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm248 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM136 192c0-30.9 25.1-56 56-56l56 0c35.5 0 64 29 64 64.3 0 24-13.4 46.2-34.9 57.2l-37.1 18.9 0 19.7-32 0 0-39.3 8.7-4.5 45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7 0-17.8-14.4-32.3-32-32.3l-56 0c-13.3 0-24 10.7-24 24l0 8-32 0 0-8zm64 136l48 0 0 48-48 0 0-48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBlockQuestion = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;